import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { map, take } from 'rxjs';
import { signedOutUrl } from '../../utils/signed-out-utils/signed-out-utils';

// Replaces Auth0's AuthGuard: no session means the signed-out page, not an automatic redirect to the login form.
export const signedInGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  return inject(AuthService).isAuthenticated$.pipe(
    take(1),
    map(isAuthenticated => isAuthenticated || router.parseUrl(signedOutUrl('expired', state.url))),
  );
};
